/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Gender information as well as how to interpret a given date of birth
 */
export type GenderOrPrenatal = 'MALE' | 'FEMALE' | 'PRENATAL';

export const GenderOrPrenatal = {
    Male: 'MALE' as GenderOrPrenatal,
    Female: 'FEMALE' as GenderOrPrenatal,
    Prenatal: 'PRENATAL' as GenderOrPrenatal
};

